module.exports = "<as-notifier></as-notifier>\n<as-image-overlay></as-image-overlay>\n<div class=\"asconsole-navbar\">\n    <as-nav-bar></as-nav-bar>\n</div>\n<div class=\"myapp licenseContainer\">\n    <ui-view></ui-view>\n</div>\n<as-loading-mask></as-loading-mask>";


//////////////////
// WEBPACK FOOTER
// ./app.component.html
// module id = 330
// module chunks = 0